/** @module Apparel/ColorSpecificationImageRenderer */
define([
    "dojo/_base/declare",
    "csi/heading/NodeImage",
    "csi/image/_base",
    "csi/reflection",
    "csi/xml"
], function(declare,NodeImage,csiImage,reflection,xml) {

    return declare(NodeImage, {
        /**
         * @override
         * Always render color image using smallest image size
         */
        reserveContext: function(ctx, h) {
            ctx.initialImageSize = ctx.prefImageSize;
            ctx.prefImageSize = reflection.IMAGE_SIZE_SMALLEST;
            this.inherited(arguments);
        },
        
        /**
         * @override
         * Restore image size
         */
        releaseContext: function(ctx, h) {
            ctx.prefImageSize = ctx.initialImageSize;
            this.inherited(arguments);
        }
    });
});